<template>
  <div class="login-page">
    <div class="login-header">
      <div class="logo-icon">
        <van-icon name="gold-coin-o" size="48" color="#fff" />
      </div>
      <h1>SharePay</h1>
      <p>博主创作中心</p>
    </div>

    <div class="login-card">
      <h3 class="card-title">账号登录</h3>
      <van-form @submit="onLogin">
        <van-field
          v-model="username"
          left-icon="user-o"
          label="用户名"
          placeholder="请输入用户名"
          :rules="[{ required: true, message: '请输入用户名' }]"
        />
        <van-field
          v-model="password"
          left-icon="lock"
          label="密码"
          placeholder="请输入密码"
          type="password"
          :rules="[{ required: true, message: '请输入密码' }]"
        />
        <van-field
          v-model="captchaCode"
          left-icon="shield-o"
          label="验证码"
          placeholder="请输入验证码"
          :rules="[{ required: true, message: '请输入验证码' }]"
        />
        <div @click="refreshCaptcha" v-html="captchaSvg" class="captcha-box" />
        <van-button
          round block native-type="submit"
          :loading="loading"
          color="linear-gradient(135deg, #6366f1, #8b5cf6)"
          class="submit-btn"
        >
          登录
        </van-button>
      </van-form>
      <div class="login-footer">
        还没有账号？<router-link to="/register">申请成为博主</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { authApi } from '../api';

export default {
  data() {
    return {
      username: '', password: '', captchaCode: '',
      captchaSvg: '', captchaKey: '', loading: false
    };
  },
  created() { this.refreshCaptcha(); },
  methods: {
    async refreshCaptcha() {
      try {
        const res = await authApi.getCaptcha();
        this.captchaSvg = res.data.svg;
        this.captchaKey = res.data.captchaKey || res.data.key;
        this.captchaCode = '';
      } catch (e) { /* ignore */ }
    },
    async onLogin() {
      this.loading = true;
      try {
        const res = await authApi.login({
          username: this.username, password: this.password,
          captchaKey: this.captchaKey, captchaCode: this.captchaCode
        });
        const { token, user } = res.data;
        if (user.role !== 'blogger') {
          this.$toast.fail('非博主账号，请使用博主账号登录');
          return;
        }
        this.$store.dispatch('login', { token, user });
        this.$router.replace(this.$route.query.redirect || '/resources');
      } catch (e) {
        this.refreshCaptcha();
      } finally { this.loading = false; }
    }
  }
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #6366f1 0%, #8b5cf6 40%, #f5f7fa 40%);
  padding-bottom: 40px;
}
.login-header {
  text-align: center;
  padding: 56px 0 36px;
  color: #fff;
}
.logo-icon {
  width: 80px; height: 80px; border-radius: 24px;
  background: rgba(255,255,255,0.2);
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 16px;
}
.login-header h1 {
  font-size: 28px; font-weight: 700; margin: 0 0 4px;
}
.login-header p {
  font-size: 14px; opacity: 0.85; margin: 0;
}
.login-card {
  margin: 0 20px;
  background: #fff;
  border-radius: 16px;
  padding: 24px 16px 20px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.08);
}
.card-title {
  font-size: 18px; font-weight: 600; text-align: center;
  margin: 0 0 16px; color: #1f2937;
}
.submit-btn { margin-top: 20px; }
.login-footer {
  text-align: center; margin-top: 16px;
  font-size: 13px; color: #9ca3af;
}
.login-footer a { color: #6366f1; font-weight: 500; }
.captcha-box {
  width: 110px; height: 42px; cursor: pointer;
  border-radius: 6px; overflow: hidden; border: 1px solid #e5e7eb;
  margin-left: auto; margin-top: -8px; margin-right: 16px;
}
.captcha-box >>> svg { width: 100%; height: 100%; }
/* 覆盖验证失败时输入框及 placeholder 的变红样式 */
.register-card >>> .van-field--error .van-field__control::placeholder {
  color: #c8c9cc !important;
  -webkit-text-fill-color: #c8c9cc !important;
}
.register-card >>> .van-field--error .van-field__control {
  color: #323233 !important;
  -webkit-text-fill-color: #323233 !important;
}
</style>
